// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a947c318","976":"772ed288","998":"0f4eea03"}[chunkId] + ".chunk.js";
};